import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider, AuthProvider, useAuth } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AppShell from "@/pages/app/AppShell";
import Dashboard from "@/pages/app/Dashboard";
import Principals from "@/pages/app/Principals";
import Intents from "@/pages/app/Intents";
import Connections from "@/pages/app/Connections";
import ConnectionDetail from "@/pages/app/ConnectionDetail";
import Admin from "@/pages/app/Admin";
import Feed from "@/pages/app/Feed";
import Profile from "@/pages/app/Profile";
import Communities from "@/pages/app/Communities";
import CommunityDetail from "@/pages/app/CommunityDetail";
import NetworkGlobe from "@/pages/app/NetworkGlobe";
import Agenda from "@/pages/app/Agenda";
import { RealtimeProvider } from "@/context/RealtimeContext";

const Loading = () => <div className="min-h-screen grid place-items-center font-mono text-xs tracking-widest text-emerald-400">AYDORIQ…</div>;

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
};

const GuestOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/app" replace /> : children;
};

function App() {
  return (
    <div className="App dark">
      <LangProvider>
        <AuthProvider>
          <RealtimeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<GuestOnly><AuthPage mode="login" /></GuestOnly>} />
              <Route path="/register" element={<GuestOnly><AuthPage mode="register" /></GuestOnly>} />
              <Route path="/app" element={<Protected><AppShell /></Protected>}>
                <Route index element={<Dashboard />} />
                <Route path="feed" element={<Feed />} />
                <Route path="communities" element={<Communities />} />
                <Route path="communities/:id" element={<CommunityDetail />} />
                <Route path="globe" element={<NetworkGlobe />} />
                <Route path="agenda" element={<Agenda />} />
                <Route path="profiles/:id" element={<Profile />} />
                <Route path="principals" element={<Principals />} />
                <Route path="intents" element={<Intents />} />
                <Route path="connections" element={<Connections />} />
                <Route path="connections/:id" element={<ConnectionDetail />} />
                <Route path="admin" element={<Protected admin><Admin /></Protected>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          </RealtimeProvider>
          <Toaster position="bottom-right" theme="dark" />
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
